import { ContentWrapper, FloatingFormItem } from '@/components/_common';
import SpaceForButton from '@/components/_common/SpaceForButtons';

import { Button, Col, Form, Row, Typography } from 'antd';

import React from 'react';
import DocumentTypesInfiniteSelectField from '@/components/_common/DocumentTypesInfiniteSelectField';
import { useRouteMatch } from 'react-router-dom';
import { useDefaultEmptyFieldError, useWindowSize } from '@/hooks';
import { QuotationGeneratePurchaseRequest } from '@/core/domain/stock/QuotationsOffers/QuotationsOffers.types';
import { useQuotationOffersGeneratePurchase } from '@/core/domain/stock/QuotationsOffers/QuotationsOffers.hooks';
import { useQuotationContext } from '..';
import { QuotationStatus } from '@/core/domain/stock/Quotations/Quotations.types';

interface QuotationGeneratePurchaseFormValues {
  documentTypeId: number;
}

const QuotationDetailsGeneratePurchasePage: React.FC = () => {
  const defaultEmptyFieldError = useDefaultEmptyFieldError();
  const [form] = Form.useForm<QuotationGeneratePurchaseFormValues>();
  const { isMobile } = useWindowSize();

  const { quotationId } = useRouteMatch<{ quotationId: string }>().params;

  const quotation = useQuotationContext();

  const generatePurchaseMutation = useQuotationOffersGeneratePurchase();

  const handleGeneratePurchase = async () => {
    const values = await form.validateFields();

    const obj: QuotationGeneratePurchaseRequest = {
      quotationId: Number(quotationId),
      ...values,
    };

    await generatePurchaseMutation.mutateAsync(obj);
  };

  return (
    <>
      <div>
        {quotation?.status !== QuotationStatus.Done ? (
          <>
            <div className="create-page-title">
              <SpaceForButton justifyContent="space-between">
                <h2>Geração de Compra</h2>
                <div>
                  <Button
                    block
                    type="primary"
                    onClick={handleGeneratePurchase}
                    loading={generatePurchaseMutation.isLoading}
                  >
                    Gerar compra
                  </Button>
                </div>
              </SpaceForButton>
            </div>

            <Form form={form}>
              <Row gutter={[24, 24]}>
                <Col span={24} lg={12}>
                  <FloatingFormItem
                    name="documentTypeId"
                    label="Tipo de documento"
                    rules={[defaultEmptyFieldError]}
                  >
                    <DocumentTypesInfiniteSelectField
                      queryFilter={{ active: true }}
                    />
                  </FloatingFormItem>
                </Col>
              </Row>
            </Form>
          </>
        ) : (
          <ContentWrapper>
            <Typography.Title
              level={isMobile ? 5 : 1}
              style={{ textAlign: 'center' }}
            >
              Processo de cotação encerrado!
            </Typography.Title>
          </ContentWrapper>
        )}
      </div>
    </>
  );
};

export default QuotationDetailsGeneratePurchasePage;
